<template>
	<div class="excel" style="overflow:hidden">
		<!-- <el-row class="row-bg-excel" style="text-align: right;">
			<el-button type="primary" @click="exportExcel">导出Excel</el-button>
		</el-row> -->
		<el-row>
			<el-col :span="24">
				<el-table @selection-change="handleSelectionChange" id="out-table" height="500" ref="multipleTable" :data="tableData" style="width: 100%;">
					<el-table-column
						type="selection"
						width="55">
					</el-table-column>
					<el-table-column align="center" label="系统生成">
						<el-table-column align="center" prop="caseNo" label="No">
							<template slot-scope="scope">
								<router-link :to="'/niceCaseInfo/'+scope.row.id">{{scope.row.caseNo}}</router-link>
							</template>
						</el-table-column>
						<el-table-column align="center" prop="month" label="月份"></el-table-column>
						<el-table-column align="center" prop="relayusername" label="NTL姓名"></el-table-column>
						<!-- <el-table-column align="center" prop="doneTypeCn" label="案件分类"></el-table-column> -->
					</el-table-column>

					<el-table-column align="center" label="DLR填写">
						<el-table-column align="center" prop="caseTypeCn" label="新规/再发起">

						</el-table-column>
						<el-table-column align="center" prop="startDatetime" label="案件发起时间(d)"></el-table-column>
						<el-table-column align="center" prop="dealerName" label="DLR名"></el-table-column>
						<el-table-column align="center" prop="vehicleType" label="车型"></el-table-column>
						<el-table-column align="center" prop="vehicleCode" label="车型代码"></el-table-column>
						<el-table-column align="center" prop="vin" label="VIN No."></el-table-column>
						<el-table-column align="center" prop="offlineDate" label="L/O"></el-table-column>
						<el-table-column align="center" prop="doneDatetime" label="入库时间"></el-table-column>
						<el-table-column align="center" prop="drivenDistance" label="行驶距离(km)"></el-table-column>
						<el-table-column align="center" prop="title" label="案件标题"></el-table-column>
						<el-table-column align="center" prop="partCn" label="部位选择"></el-table-column>
						<el-table-column align="center" prop="phenomenonCn" label="现象分类"></el-table-column>
						<el-table-column align="center" prop="dtcint" label="DTC有无"></el-table-column>
						<el-table-column align="center" prop="dtc" label="DTC"></el-table-column>
						<el-table-column align="center" prop="kubun" label="维修类型"></el-table-column>
						<el-table-column align="center" label="咨询内容">
							<el-table-column align="center" prop="customerConsultation" label="顾客描述"></el-table-column>
							<el-table-column align="center" prop="phenomenonConfirmation" label="现象确认"></el-table-column>
							<el-table-column align="center" prop="inspectionDiagnosis" label="检查内容"></el-table-column>
							<el-table-column align="center" prop="supportDiagnosis" label="请求支援内容"></el-table-column>
						</el-table-column>
					</el-table-column>

					<el-table-column align="center" label="NTL对应情况（TMCI填写）">
						<el-table-column align="center" prop="dlrQualityCn" label="DLR情报质量"></el-table-column>
						<el-table-column align="center" prop="backCount" label="退回次数"></el-table-column>
						<el-table-column align="center" prop="casePriorityCN" label="案件重要度"></el-table-column>
						<el-table-column align="center" prop="difficultyCn" label="案件难易度"></el-table-column>
						<el-table-column align="center" prop="firstReplyDatetime" label="初次答复时间"></el-table-column>
						<el-table-column align="center" prop="firstReplyContent" label="初次答复内容(W)"></el-table-column>
						<el-table-column align="center" prop="firstReplyElapsed" label="初次答复经过时间"></el-table-column>
						<el-table-column align="center" prop="directionsCN" label="对应方向【非必选项】(z)"></el-table-column>
						<el-table-column align="center" prop="directionDateDistance" label="对应方向确定时间"></el-table-column>
						<el-table-column align="center" prop="recognitionDate" label="现认时间(AB)"></el-table-column>
						<el-table-column align="center" prop="recognitionReason" label="未现认理由"></el-table-column>
						<el-table-column align="center" prop="rsrReleaseTime" label="RSR发行时间"></el-table-column>
						<el-table-column align="center" prop="rsrReleaseReason" label="RSR未发行理由"></el-table-column>
						<el-table-column align="center" prop="rscStartTime" label="RSC入手时间"></el-table-column>
						<el-table-column align="center" prop="finalSolution" label="最终对应方案（AG）"></el-table-column>
						<el-table-column align="center" prop="finalSolutionDate" label="最终对应方案提出时间"></el-table-column>
						<el-table-column align="center" prop="dlrStatus[0]" label="结案状态(AI)"></el-table-column>
						<el-table-column align="center" prop="doneDate" label="DLR确认结案时间"></el-table-column>
						<el-table-column align="center" prop="followup" label="跟进必要性(AK)"></el-table-column>
						<el-table-column align="center" prop="followupDirection" label="跟进方向"></el-table-column>
						<el-table-column align="center" prop="reportNo" label="技术现认、支援报告书编号"></el-table-column>
						<el-table-column align="center" prop="reportNoDates" label="报告书发行时间（AN）"></el-table-column>
						<el-table-column align="center" prop="reportDateDistance" label="报告发行LT"></el-table-column>
						<!-- <el-table-column align="center" prop="fieldId" label="区域code"></el-table-column> -->
						<el-table-column align="center" prop="area" label="区域名称"></el-table-column>
					</el-table-column>
					<el-table-column align="center" prop="elapsedForExcel" label="最终对应方案经过的工作时间"></el-table-column>
					<el-table-column align="center" prop="alarmInfoColour" label="颜色"></el-table-column>
					<el-table-column align="center" prop="alarmInfoTimes" label="次数"></el-table-column>
					<el-table-column align="center" prop="alarmInfoDays" label="时间">
						<template slot-scope="scope">
							{{scope.row.alarmInfoDays}}天
						</template>
					</el-table-column>
					<el-table-column align="center" prop="partsNameElapsed" label="零件"></el-table-column>
					<el-table-column align="center" width="240" prop="partsNameElapsed" fixed="right" label="操作">
						<template slot-scope="scope">
							<el-button size="mini" @click="jumpFn(scope.row.id)">查看</el-button>
							<el-button size="mini" @click="editFn(scope.row.id)" type="primary">编辑</el-button>
							<el-button size="mini" @click="delFn(scope.row.id)" type="danger">删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="24" align="center">
				<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNumber"
				 :page-sizes="[20, 30, 40, 50, 100, 200, 5000]" :pager-count="5" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				 :total="total">
				</el-pagination>
			</el-col>
		</el-row>
	</div>
</template>

<script>
import { getNiceCaseData, deleteFn } from '@/api/nicecase'
import FileSaver from 'file-saver'
import XLSX from 'xlsx'
export default {
  data () {
    return {
      pageSize: null,
      total: null,
      pageNumber: 1,
      formData: {
      },
      selectData: {
        caseTypeOption: [null],
        phenomenonOption: [null],
        difficultyOption: [null],
        partOption: [null],
        directionOption: [null],
        status: [null],
        areaList: [null],
        leaders: [null],
        dlrQualityOption: [],
        casePriorityOption: [],
        followupOption: [],
        dtcOption: [],
        dlrStatusOption: []
      },
      tableData: [],
      sgareaList: [],
      sgleaders: [],
	  multipleSelection: []
    }
  },
  methods: {
	  jumpFn(val) {
		  this.$router.push({ path: '/niceCaseInfo/' +  val })
	  },
	  editFn(val) {
		  this.$router.push({ path: '/addedNiceCase/' + val })
	  },
	  delFn(val) {
		  this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
			}).then(() => {
				deleteFn(val).then(res => {
					this.$message({
						type: 'success',
						message: '删除成功!'
					})
					this.submit()
				})
			
			}).catch(() => {
			this.$message({
				type: 'info',
				message: '已取消删除'
			});          
			});
		  
	  },
	pushFn() {
		console.log(this.multipleSelection)
		const data = this.multipleSelection.map(item => item.id)
		pushCases(data).then(res => {
			this.$message({
				type: 'success',
				message: '推送成功'
			})
		})
	},
	handleSelectionChange(val){
		this.multipleSelection = val
	},
    // 导出表格
    exportExcel () {
      /* generate workbook object from table */
      var wb = XLSX.utils.table_to_book(document.querySelector('#out-table'))
      /* get binary string as output */
      var dataInfo = wb.Sheets[wb.SheetNames[0]]
      for (var v in dataInfo) {
        if (dataInfo[v].hasOwnProperty('z') && dataInfo[v].z == 'm/d/yy') {
          dataInfo[v].v = dataInfo[v].v - 0.00050000
          dataInfo[v].z = 'yyyy/mm/dd HH:MM:SS'
        }
      }
      var wbout = XLSX.write(wb, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array'
      })
      try {
        FileSaver.saveAs(new Blob([wbout], {
          type: 'application/octet-stream'
        }), 'Li-TCS输出表格.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, wbout)
      }
      return wbout
    },

    // 当页面条数改变时
    handleSizeChange (val) {
      this.pageSize = val
      let that = this
      getTableData(this.pageSize, 0, this.formData).then(res => {
        that.tableData = res.data.content
      })
    },
    // 当页码改变时
    handleCurrentChange (val) {
      let pageNumber = val - 1
      let that = this
      getTableData(this.pageSize, pageNumber, this.formData).then(res => {
        that.tableData = res.data.content
      })
    },
    // 检索数据
    submit () {
      let that = this
      getNiceCaseData(this.pageNumber - 1, this.pageSize, this.formData).then(res => {
        that.tableData = res.data.content
        that.total = res.data.totalElements
        that.pageNumber = 1
      })
    }
  },
  mounted () {
    let that = this
    getNiceCaseData(this.pageNumber - 1, this.pageSize, this.formData).then(res => {
      // console.log(res.data.content[0])
      that.tableData = res.data.content
      that.pageSize = res.data.size
      that.total = res.data.totalElements
    })
  }
}
</script>

<style scoped="scoped">
.excel {
	text-align: left;
}

.block {
	line-height: 40px;
	display: flex;
	/* justify-content: space-around; */
}

.block .title {
	min-width: 85px;
	/* text-align: center; */
}

.time {
	/* max-width: 245px; */
}

.timebox {
	display: flex;
}

.row-bg-excel {
	margin-right: 100px;
}

</style>
